export const patterns = {
    namePattern: "^[а-яА-ЯёЁa-zA-Z0-9 -]+$",
    emailPattern: "^([A-z0-9_.-]{1,})@([A-z0-9_.-]{1,}).([A-z]{2,8})$", 
    linkPattern: "^(https?:\\/\\/)?' // protocol((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$"
}
